import { useMemo } from 'react';
import useWindowSize from './useWindowSize';
import { Breakpoints } from '@volkswagen-onehub/components-core';

const useBreakpoint = () => {
  const { width } = useWindowSize();

  const bp = useMemo(() => {
    const b560 = Number(Breakpoints.b560);
    const b960 = Number(Breakpoints.b960);
    const b1280 = Number(Breakpoints.b1280);
    const b1600 = Number(Breakpoints.b1600);

    const isMobile = width < b560;
    const isTablet = width >= b560 && width < b960;
    const isSmallDesktop = width >= b960 && width < b1280;
    const isDesktop = width >= b1280 && width < b1600;
    const isLargeDesktop = width >= b1600;

    return {
      isMobile,
      isTablet,
      isSmallDesktop,
      isDesktop,
      isLargeDesktop,
      width,
    };
  }, [width]);

  return bp;
};

export default useBreakpoint;
